"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectInitialCards = void 0;
const vue_1 = require("vue");
const Button_1 = require("./common/Button");
const CardFinder_1 = require("../CardFinder");
const CardName_1 = require("../CardName");
const constants = require("../constants");
const SelectCard_1 = require("./SelectCard");
const ConfirmDialog_1 = require("./common/ConfirmDialog");
const PreferencesManager_1 = require("./PreferencesManager");
const Colony_1 = require("../components/Colony");
exports.SelectInitialCards = vue_1.default.component('select-initial-cards', {
    props: {
        player: {
            type: Object,
        },
        playerinput: {
            type: Object,
        },
        onsave: {
            type: Function,
        },
        showsave: {
            type: Boolean,
        },
        showtitle: {
            type: Boolean,
        },
    },
    components: {
        Button: Button_1.Button,
        'select-card': SelectCard_1.SelectCard,
        'confirm-dialog': ConfirmDialog_1.ConfirmDialog,
        Colony: Colony_1.Colony,
    },
    data: function () {
        return {
            selectedCards: [],
            selectedCorporation: undefined,
            selectedPrelude: [],
            selectedLeaders: [],
        };
    },
    methods: {
        getAfterPreludes: function () {
            var _a;
            let result = 0;
            for (const prelude of this.selectedPrelude) {
                switch (prelude) {
                    case CardName_1.CardName.ALLIED_BANKS:
                    case CardName_1.CardName.ANTI_DESERTIFICATION_TECHNIQUES:
                        result += 3;
                        break;
                    case CardName_1.CardName.BUSINESS_EMPIRE:
                        result -= 6;
                        break;
                    case CardName_1.CardName.AQUIFER_TURBINES:
                    case CardName_1.CardName.STRATEGIC_BASE_PLANNING:
                        result -= 3;
                        break;
                    case CardName_1.CardName.MINING_IMPROVEMENTS:
                        result -= 2;
                        break;
                    case CardName_1.CardName.DONATION:
                        result += 21;
                        break;
                    case CardName_1.CardName.GALILEAN_MINING:
                    case CardName_1.CardName.HUGE_ASTEROID:
                    case CardName_1.CardName.VITAL_COLONY:
                    case CardName_1.CardName.MAIN_BELT_ASTEROIDS:
                        result -= 5;
                        break;
                    case CardName_1.CardName.TERRAFORMING_MISSION:
                        result -= 12;
                        break;
                    case CardName_1.CardName.LOAN:
                        result += 30;
                        break;
                    case CardName_1.CardName.MARTIAN_INDUSTRIES:
                    case CardName_1.CardName.VALUABLE_GASES:
                        result += 6;
                        break;
                    case CardName_1.CardName.NITROGEN_SHIPMENT:
                    case CardName_1.CardName.GAMBLING_HOUSE:
                    case CardName_1.CardName.NOBEL_PRIZE:
                        result += 5;
                        break;
                    case CardName_1.CardName.SOLAR_BATTERIES:
                        result += 7;
                        break;
                    case CardName_1.CardName.AEROSPACE_MISSION:
                        result -= 14;
                        break;
                    case CardName_1.CardName.FORTIFIED_OUTPOST:
                        result -= 10;
                        break;
                    case CardName_1.CardName.RESEARCH_GRANT:
                        result += 8;
                        break;
                    case CardName_1.CardName.TRADE_ADVANCE:
                        result += 2;
                        break;
                    case CardName_1.CardName.STAKEHOLDERS:
                        result += 14;
                        break;
                    case CardName_1.CardName.EXECUTIVE_ORDER:
                    case CardName_1.CardName.RECESSION:
                        result += 10;
                        break;
                    case CardName_1.CardName.CORPORATE_ARCHIVES:
                        result += 13;
                        break;
                    case CardName_1.CardName.ESTABLISHED_METHODS:
                        result += 30;
                        break;
                    case CardName_1.CardName.CORRIDORS_OF_POWER:
                        result += 4;
                        break;
                    case CardName_1.CardName.INDUSTRIAL_COMPLEX:
                        result -= 18;
                        break;
                    case CardName_1.CardName.HEAD_START:
                        result += this.selectedCards.length * 2;
                        break;
                }
                switch ((_a = this.selectedCorporation) === null || _a === void 0 ? void 0 : _a.name) {
                    case CardName_1.CardName.MANUTECH:
                        switch (prelude) {
                            case CardName_1.CardName.ALLIED_BANKS:
                                result += 4;
                                break;
                            case CardName_1.CardName.BUSINESS_EMPIRE:
                                result += 6;
                                break;
                            case CardName_1.CardName.DOME_FARMING:
                            case CardName_1.CardName.SELF_SUFFICIENT_SETTLEMENT:
                                result += 2;
                                break;
                            case CardName_1.CardName.METALS_COMPANY:
                            case CardName_1.CardName.RESEARCH_NETWORK:
                            case CardName_1.CardName.THARSIS_PROTOTYPE_CITY:
                                result += 1;
                                break;
                            case CardName_1.CardName.NITRATE_REDUCERS:
                            case CardName_1.CardName.RISE_TO_POWER:
                                result += 3;
                                break;
                        }
                        break;
                    case CardName_1.CardName.THARSIS_REPUBLIC:
                        switch (prelude) {
                            case CardName_1.CardName.SELF_SUFFICIENT_SETTLEMENT:
                            case CardName_1.CardName.EARLY_SETTLEMENT:
                            case CardName_1.CardName.FORTIFIED_OUTPOST:
                            case CardName_1.CardName.PROJECT_EDEN:
                            case CardName_1.CardName.STRATEGIC_BASE_PLANNING:
                                result += 3;
                                break;
                        }
                        break;
                    case CardName_1.CardName.PHARMACY_UNION:
                        switch (prelude) {
                            case CardName_1.CardName.BIOFUELS:
                            case CardName_1.CardName.ECOLOGY_EXPERTS:
                            case CardName_1.CardName.NITRATE_REDUCERS:
                            case CardName_1.CardName.ANTI_DESERTIFICATION_TECHNIQUES:
                            case CardName_1.CardName.SOIL_BACTERIA:
                                result -= 4;
                                break;
                        }
                        break;
                    case CardName_1.CardName.SPLICE:
                        switch (prelude) {
                            case CardName_1.CardName.BIOFUELS:
                            case CardName_1.CardName.ECOLOGY_EXPERTS:
                            case CardName_1.CardName.NITRATE_REDUCERS:
                            case CardName_1.CardName.ANTI_DESERTIFICATION_TECHNIQUES:
                            case CardName_1.CardName.SOIL_BACTERIA:
                                result += 4;
                                break;
                        }
                        break;
                    case CardName_1.CardName.APHRODITE:
                        switch (prelude) {
                            case CardName_1.CardName.VENUS_FIRST:
                                result += 4;
                                break;
                            case CardName_1.CardName.HYDROGEN_BOMBARDMENT:
                            case CardName_1.CardName.GIANT_SOLAR_COLLECTOR:
                                result += 2;
                                break;
                            case CardName_1.CardName.VENUS_L1_SHADE:
                                result += 6;
                                break;
                        }
                        break;
                    case CardName_1.CardName.SAGITTA_FRONTIER_SERVICES:
                        const cardFinder = new CardFinder_1.CardFinder();
                        const preludeCard = cardFinder.getProjectCardByName(prelude);
                        const tagCount = preludeCard.tags.length;
                        if (tagCount === 0) {
                            result += 4;
                        }
                        else if (tagCount === 1) {
                            result += 1;
                        }
                        break;
                }
            }
            return result;
        },
        getOption: function (idx) {
            if (this.playerinput.options === undefined || this.playerinput.options[idx] === undefined) {
                throw new Error('invalid input, missing option');
            }
            return this.playerinput.options[idx];
        },
        getProjectCardsOption: function () {
            let optionIndex = 1;
            if (this.hasPrelude() && this.hasLeaders())
                optionIndex = 3;
            if (this.hasPrelude() && !this.hasLeaders())
                optionIndex = 2;
            if (!this.hasPrelude() && this.hasLeaders())
                optionIndex = 2;
            return this.getOption(optionIndex);
        },
        getStartingMegacredits: function () {
            if (this.selectedCorporation === undefined) {
                return NaN;
            }
            let starting = this.selectedCorporation.startingMegaCredits;
            let cardCost = this.selectedCorporation.cardCost === undefined ? constants.CARD_COST : this.selectedCorporation.cardCost;
            if (this.player.automaBotCorporation.name === CardName_1.CardName.POLYPHEMOS_BOT) {
                cardCost += 2;
            }
            starting -= this.selectedCards.length * cardCost;
            return starting;
        },
        saveIfConfirmed: function () {
            if (PreferencesManager_1.PreferencesManager.load('show_alerts') === '1' && this.selectedCards.length === 0) {
                this.$refs['confirmation'].show();
            }
            else {
                this.saveData();
            }
        },
        saveData: function () {
            const result = [];
            result.push([]);
            if (this.selectedCorporation !== undefined) {
                result[0].push(this.selectedCorporation.name);
            }
            if (this.hasPrelude()) {
                result.push(this.selectedPrelude);
            }
            if (this.hasLeaders()) {
                result.push(this.selectedLeaders);
            }
            const corporationPicked = this.selectedCorporation !== undefined;
            const twoPreludesPicked = !this.hasPrelude() || (this.hasPrelude() && this.selectedPrelude.length === 2);
            const leaderPicked = !this.hasLeaders() || (this.hasLeaders() && this.selectedLeaders.length === 1);
            if (corporationPicked && twoPreludesPicked && leaderPicked) {
                result.push(this.selectedCards);
            }
            this.onsave(result);
        },
        playerCanChooseAridor: function () {
            return this.player.dealtCorporationCards.some((card) => card.name === CardName_1.CardName.ARIDOR);
        },
        hasPrelude: function () {
            return this.playerinput.options !== undefined && this.player.gameOptions.preludeExtension;
        },
        hasLeaders: function () {
            return this.playerinput.options !== undefined && this.player.gameOptions.leadersExpansion;
        },
        cardsChanged: function (cards) {
            this.selectedCards = cards;
        },
        corporationChanged: function (cards) {
            this.selectedCorporation = new CardFinder_1.CardFinder().getCorporationCardByName(cards[0]);
        },
        preludesChanged: function (cards) {
            this.selectedPrelude = cards;
        },
        leadersChanged: function (cards) {
            this.selectedLeaders = cards;
        },
        confirmSelection: function () {
            this.saveData();
        },
    },
    template: `
  <div class="select-initial-cards">
    <confirm-dialog
      message="Continue without buying initial cards?"
      ref="confirmation"
      v-on:accept="confirmSelection" />
    <select-card :player="player" :playerinput="getOption(0)" :showtitle="true" v-on:cardschanged="corporationChanged" />
    <div v-if="playerCanChooseAridor()" class="player_home_colony_cont">
      <div v-i18n>These are the colony tiles Aridor may choose from:</div>
      <div class="discarded-colonies-for-aridor">
        <div class="player_home_colony small_colony" v-for="colony in player.discardedColonies" :key="colony.name">
          <colony :colony="colony"></colony>
        </div>
      </div>
    </div>
    <select-card v-if="hasPrelude()" :player="player" :playerinput="getOption(1)" :showtitle="true" v-on:cardschanged="preludesChanged" />
    <select-card v-if="hasLeaders()" :player="player" :playerinput="getOption(hasPrelude() ? 2 : 1)" :showtitle="true" v-on:cardschanged="leadersChanged" />
    <select-card :player="player" :playerinput="getProjectCardsOption()" :showtitle="true" v-on:cardschanged="cardsChanged" />
    <div v-if="selectedCorporation" v-i18n>Starting Megacredits: <div class="megacredits">{{getStartingMegacredits()}}</div></div>
    <div v-if="selectedCorporation && hasPrelude()" v-i18n>After Preludes: <div class="megacredits">{{getStartingMegacredits() + getAfterPreludes()}}</div></div>
    <Button v-if="showsave" :onClick="saveIfConfirmed" type="submit" :title="playerinput.buttonLabel" />
  </div>`,
});
//# sourceMappingURL=SelectInitialCards.js.map